import React from 'react';
import VirtualHubLogo from '@/assets/virtual-hub-logo.png';
import IsatULogo from '@/assets/ISAT-U-logo.png';

interface LogoGroupProps {
  /** Custom classes for the container */
  containerClassName?: string;
  /** Custom classes for the Virtual Hub logo */
  virtualHubClassName?: string;
  /** Custom classes for the ISAT-U logo */
  isatUClassName?: string;
  /** Layout direction - defaults to 'horizontal' */
  direction?: 'horizontal' | 'vertical';
  /** Gap between logos - defaults to 'gap-4' */
  gap?: string;
  /** Whether to show both logos or just one */
  showVirtualHub?: boolean;
  showIsatU?: boolean;
}

const LogoGroup: React.FC<LogoGroupProps> = ({
  containerClassName = '',
  virtualHubClassName = 'h-20 sm:h-20 w-auto',
  isatUClassName = 'h-20 sm:h-20 w-auto',
  direction = 'horizontal',
  gap = 'gap-4',
  showVirtualHub = true,
  showIsatU = true,
}) => {
  const flexDirection = direction === 'vertical' ? 'flex-col' : 'flex-row';
  const baseClasses = `flex ${flexDirection} ${gap}`;

  return (
    <div className={`${baseClasses} ${containerClassName}`}>
      {showVirtualHub && (
        <img
          src={VirtualHubLogo}
          alt="Virtual Hub Logo"
          className={virtualHubClassName}
        />
      )}
      {showIsatU && (
        <img src={IsatULogo} alt="ISAT-U Logo" className={isatUClassName} />
      )}
    </div>
  );
};

export default LogoGroup;
